import { useMemo } from 'react';
import styled from 'styled-components';
import OverviewSection from '../overviewSection';
import SubRTableView from '../../SubRTableView';
import { calculateTotalTableData } from '../../../helpers/utils';
import NoDataUI from '../NoDataUI';

interface ITableViewSectionProps {
  currentReportWidget: string;
  contentData: any;
  value: string;
}

const TableViewSection = ({ contentData, value }: ITableViewSectionProps) => {
  const transformedData = useMemo(() => {
    const rawData = contentData?.data ?? [];
    const config = contentData?.config;

    if (!rawData.length) return null;

    const currency = config?.currency_code ?? '';
    const currencyPrecision = config?.currency_precision ?? 2;

    const firstRow = rawData[0];

    // Transform data by adding serial numbers
    const tableData = rawData.map((row: any, index: number) => ({
      ...row,
      sr_no: index + 1
    }));

    return {
      subHeading: {
        label: 'Location: ',
        value: firstRow.location || ''
      },
      overview: {
        details: [],
        summary: {
          label: 'Comments',
          value: firstRow.comments || ''
        }
      },
      table: {
        columns: [
          {
            header: 'Sr. No',
            accessor: 'sr_no'
          },
          {
            header: 'Items',
            accessor: 'items'
          },
          {
            header: `Cost (${currency}) / Unit`,
            accessor: 'cost_unit'
          },
          {
            header: 'Unit Value',
            accessor: 'unit_value'
          },
          {
            header: 'Issue Quantity',
            accessor: 'issued_quantity'
          },
          {
            header: `Total (${currency})`,
            accessor: 'total'
          }
        ],
        data: tableData
      },
      total: {
        label: 'Total',
        value: calculateTotalTableData(rawData, 'total', currencyPrecision)
      }
    };
  }, [contentData]);

  if (!transformedData) {
    return (
      <Wrapper>
        <NoDataUI />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div style={{ width: '100%', height: '100%' }}>
        <OverviewSection
          overviewData={transformedData.overview}
          location={transformedData.subHeading}
          reportId={value}
        />
        <SubRTableView
          data={{
            ...transformedData.table,
            config: contentData.config,
            total: transformedData.total
          }}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`;

export default TableViewSection;
